import React from "react";
import PropTypes from "prop-types";
import Event from "./Event";
import _ from "lodash";
import { connect } from "react-redux";
import Steps, { Step } from "rc-steps";
import { compose } from "recompose";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import {contractStateName} from"./ContractList";

const currentState = (state_position, state) => {
  switch (state) {
    case "waiting_for_parts":
      return state_position - 1;
    case "hold":
      return state_position - 2;
    case "waiting_for_payment":
      return state_position - 2;
    case "waiting_for_pickup":
      return state_position - 2;
    case "completed":
      return state_position - 2;
    case "cancelled":
      return state_position - 2;
    default:
      return state_position;
  }
};

const inService = state => {
  if (state === "hold" || state === "waiting_for_parts") {
    switch (state) {
      case "hold":
        state = "On hold";
        break;
      case "waiting_for_parts":
        state = "Waiting for parts";
        break;
      default:
        break;
    }
    return state;
  }
  return undefined;
};

function printEvent(events, currentContract) {
  return currentContract.contract_states.map((state, index) => {
    if (
      state !== "hold" &&
      state !== "waiting_for_parts" &&
      state !== "cancelled"
    ) {
      return (
        <Step
          title={contractStateName(state)}
          icon={
            index <= currentContract.state_position ? (
              <Icon type={"dot-circle"} />
            ) : (
              <Icon type={faCircle} />
            )
          }
          status={
            currentContract.contract_states[currentContract.state_position] ===
              "hold" ||
            currentContract.contract_states[currentContract.state_position] ===
              "waiting_for_parts"
              ? "wait"
              : undefined
          }
          description={
            <>
              <b>
                {state === "in_service"
                  ? inService(
                      currentContract.contract_states[
                        currentContract.state_position
                      ]
                    )
                  : undefined}
              </b>
              <Event
                events={events}
                currentState={currentContract.contract_states[index]}
              />{" "}
            </>
          }
        />
      );
    }
    if (
      currentContract.contract_states[currentContract.state_position] ===
        "cancelled" &&
      state === "cancelled"
    ) {
      return (
        <Step
          title={contractStateName(state)}
          icon={<Icon type={"exclamation-triangle"} />}
          status={"error"}
          description={
            <Event
              events={events}
              currentState={currentContract.contract_states[index]}
            />
          }
        />
      );
    }
    return null;
  });
}

const mapStateToProps = state => ({
  currentContract: state.contracts.currentContract
});

const withReduxState = connect(mapStateToProps);

const Icon = ({ type }) => (
  <i className={`rcicon`}>
    <FontAwesomeIcon icon={type} />
  </i>
);

export function currentStatus(state) {
  if (state === "canceled") {
    return "error";
  }
  if (state === "completed") {
    return "finished";
  }
  if (state === "hold" || state === "waiting_for_parts") {
    return "wait";
  }
  return undefined;
}
const EventSection = ({ currentContract, events }) => {
  if (_.isEmpty(events)) {
    return (
      <h4 className="text-muted">
        There are no history events in this contract.
      </h4>
    );
  }

  return (
    <div className="pt-2">
      <Steps
        current={currentState(
          currentContract.state_position,
          currentContract.contract_states[currentContract.state_position]
        )}
        status={currentStatus(
          currentContract.contract_states[currentContract.state_position]
        )}
        size={"small"}
        direction="vertical"
      >
        {printEvent(events, currentContract)}
      </Steps>
    </div>
  );
};

EventSection.propTypes = {
  events: PropTypes.array.isRequired
};

export default compose(withReduxState)(EventSection);
